import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SignUpOptions } from 'src/app/auth/models/sign-up-options.model';
import { Auth0Error } from './models/auth0-error.model';

export const SignUpFormActions = createActionGroup({
  source: 'Sign Up Form',
  events: {
    'Sign Up Clicked': props<{ options: SignUpOptions }>(),
    'View Destroyed': emptyProps(),
  },
});

export const SignUpEffectActions = createActionGroup({
  source: 'Sign Up Effect',
  events: {
    'Sign Up Succeeded': props<{ userId: string }>(),
    'Sign Up Errored': props<{ error: Auth0Error }>(),
    'Redirected to Sign In': emptyProps(),
    'Redirected to Verify Email': emptyProps(),
  },
});
